import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-right" }
const _hoisted_2 = { class: "modal-header scroll-wrapper" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-body scroll-wrapper" }
const _hoisted_5 = { class: "content-number-package" }
const _hoisted_6 = { class: "number-package" }
const _hoisted_7 = { class: "builder-logo-wr" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "house-info-card-header" }
const _hoisted_10 = { class: "container-lot" }
const _hoisted_11 = {
  key: 0,
  class: "number-lot"
}
const _hoisted_12 = { class: "container-edit-delete" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "house-info-card-row" }
const _hoisted_18 = { class: "row-value" }
const _hoisted_19 = { class: "house-info-card-row" }
const _hoisted_20 = { class: "row-value" }
const _hoisted_21 = { class: "house-info-card-row" }
const _hoisted_22 = { class: "row-value color-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    transitionName: 'modal-slide',
    classes: ['select-builder-quotes-lists-modal']
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "Your Packages (" + _toDisplayString($setup.requestQuoteCounter) + ")", 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "line" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userSelections, (selection, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["house-info-card", { selected: selection?.id === $setup.selectedQuote?.id }]),
              key: index
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, "PACKAGE " + _toDisplayString(index + 1), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (selection?.builder.id)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: selection.builder.logo,
                      alt: "builder logo"
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (selection?.lot.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Lot " + _toDisplayString(selection.lot.name), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "button button-with-icon",
                    onClick: ($event: any) => ($setup.onUpdateUserSelection(selection.id))
                  }, [
                    _createElementVNode("img", {
                      src: require(`@/assets/icons/edit-slate-icon.svg`)
                    }, null, 8, _hoisted_14)
                  ], 8, _hoisted_13),
                  _createElementVNode("button", {
                    class: "button button-with-icon",
                    onClick: ($event: any) => ($setup.onDeleteUserSelection(selection.id))
                  }, [
                    _createElementVNode("img", {
                      src: require(`@/assets/icons/trash-slate-icon.svg`)
                    }, null, 8, _hoisted_16)
                  ], 8, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "Builder", -1)),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(selection.builder.name), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "House Design", -1)),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(selection.house.name), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-label" }, "Exterior Facade", -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(selection.facade?.name), 1)
                ])
              ])
            ], 2))
          }), 128)),
          _createElementVNode("button", {
            class: "button default primary add-btn create-home",
            onClick: $setup.onGetMoreQuotes
          }, "Create another home & land package")
        ]),
        _createElementVNode("footer", { class: "modal-footer" }, [
          _createElementVNode("button", {
            class: "button primary",
            onClick: $setup.submit
          }, "Get Prices")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}